import { render, staticRenderFns } from "./CommonUidTokenLoginPopup.vue?vue&type=template&id=c98c39c0&scoped=true&"
import script from "./CommonUidTokenLoginPopup.vue?vue&type=script&lang=js&"
export * from "./CommonUidTokenLoginPopup.vue?vue&type=script&lang=js&"
import style0 from "./CommonUidTokenLoginPopup.vue?vue&type=style&index=0&id=c98c39c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98c39c0",
  null
  
)

export default component.exports